module.exports = __webpack_public_path__ + "static/media/insulation_gwp_10y_y.41f316ae.csv";